<template>
  <div class="table-footer">
    <div class="row">
      <div class="col-md-4">
        <span>Show</span>
        <select
          class="form-control"
          v-model="showPerPage"
          id="resultsPerPage"
          @change="showPerPageChanged"
        >
          <option>10</option>
          <option>25</option>
          <option>50</option>
          <option>100</option>
        </select>
        <span>entries</span>
      </div>
      <div class="col-md-4 text-center"></div>
      <div class="col-md-4 text-right">
        <a
          href="javascript:void(0)"
          v-if="currentPageNumber != 1"
          @click="getPreviousPageList()"
          >Previous
        </a>
        <select
          class="form-control selectpicker"
          style="max-width: 70px; padding: 2px"
          id="brandFilter"
          v-model="currentPageNumber"
          @change="getNewPageList()"
        >
          <option v-for="index in totalNoOfPages" :key="index" :value="index">
            {{ index }}
          </option>
        </select>
        <a
          href="javascript:void(0)"
          v-if="
            showPerPage == keywordDescList.length &&
            currentPageNumber != totalNoOfPages
          "
          @click="getNextPageList()"
        >
          Next</a
        >
        <div style="padding-right: 0px; padding-top: 5px">{{ getCount() }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KeyDescFooter",
  data() {
    return {
      totalNoOfPages: 1,
    };
  },
  watch: {
    totalKeywordDescCount() {
      this.calculateIndexPerPage();
    },
  },
  computed: {
    totalKeywordDescCount: {
      set(val) {
        this.$store.state.totalKeywordDescCount = val;
      },
      get() {
        return this.$store.state.totalKeywordDescCount;
      },
    },
    showPerPage: {
      set(val) {
        this.$store.state.keywordDescShowPerPage = val;
      },
      get() {
        return this.$store.state.keywordDescShowPerPage;
      },
    },
    currentPageNumber: {
      set(val) {
        this.$store.state.keywordDescCurrentPageNumber = val;
      },
      get() {
        return this.$store.state.keywordDescCurrentPageNumber;
      },
    },
    keywordDescList() {
      return this.$store.state.keywordDescList;
    },
  },
  mounted() {
    this.calculateIndexPerPage();
  },
  methods: {
    calculateIndexPerPage() {
      this.totalNoOfPages = Math.ceil(
        this.totalKeywordDescCount / this.showPerPage
      );
    },
    getPreviousPageList() {
      if (this.currentPageNumber <= 1) {
        return;
      } else {
        this.currentPageNumber -= 1;
        this.fetchKeyDescData()
        // this.$store.dispatch("campaign/getCampaignGroupList");
      }
    },
    getNextPageList() {
      this.currentPageNumber += 1;
      this.fetchKeyDescData()
    //   this.$store.dispatch("campaign/getCampaignGroupList");
    },
    getNewPageList() {
      this.fetchKeyDescData()
    //   this.$store.dispatch("campaign/getCampaignGroupList");
    },
    getCount() {
      let pageCount = this.showPerPage * (this.currentPageNumber - 1);
      let extendedcount =
        parseInt(pageCount) + parseInt(this.keywordDescList.length);
      return (
        "Showing " +
        (pageCount + 1) +
        " to " +
        extendedcount +
        " results of " +
        this.totalKeywordDescCount
      );
    },
    showPerPageChanged() {
      this.currentPageNumber = 1;
      this.fetchKeyDescData()
    //   this.$store.dispatch("campaign/getCampaignGroupList");
    },
    fetchKeyDescData(){
        this.$emit('fetchKeywordDescData')
    }
  },
};
</script>

<style lang="scss">
</style>
